
<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    国贸站<br>
站点介绍<br>
国贸站位于深圳市商业中心人民南路与嘉宾路交叉路口处。站位所在路口的东北角有国内知名度很高的国际贸易大厦，东南角是南国影院下沉式绿化广场，西南角是国际商业大厦。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:22	00:06	1号线	2分钟	4分40秒<br>
机场东	06:22	23:02	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:22	00:04	1号线	3分45秒	5分45秒<br>
机场东	06:22	23:02	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:22	01:04	1号线	3分45秒	5分45秒<br>
机场东	06:22	00:02	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
南湖派出所、深圳市南湖小学、嘉宾路南侧（东）、人民南路东侧（南）、罗湖医院<br><br>
B出入口:<br>
深南东路<br><br>
C出入口:<br>
深圳国际贸易中心大厦（国贸）、东门步行街、深圳天安国际大厦、人民南路东侧（东南）<br><br>
D出入口:<br>
（暂未开通）E出入口<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 金光华广场<br><br>
82、M205、306、307、381、M403、M404、M407、M408、M508、N14、N16<br><br>
B出入口:<br>
公交站名： 金光华广场<br>
1、82、M205、306、307、351、381、M402、M403、M404、M407、M408、M508、N14、N16、N7<br><br>
C出入口:<br>
公交站名： 国贸①<br>
1、11、M156、高峰专线290、E8<br><br>
E出入口:<br>
公交站名： 罗湖小学②<br>
1、12、38、215、M152、M401、N7、N14<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>






